import { render, staticRenderFns } from "./duibifenxiangbi.vue?vue&type=template&id=2cda3c7c&scoped=true&"
import script from "./duibifenxiangbi.vue?vue&type=script&lang=js&"
export * from "./duibifenxiangbi.vue?vue&type=script&lang=js&"
import style0 from "./duibifenxiangbi.vue?vue&type=style&index=0&id=2cda3c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda3c7c",
  null
  
)

export default component.exports